module.exports = __webpack_public_path__ + "img/404-error.69c1f21f.svg";